// Maps the WebSocket spec's uppercase channel names
// (TELEMETRY_PAYLOAD_SPECIFICATION-2.md §8.1: FHR1, FHR2, TOCO, MHR, SPO2,
// BP, TEMP) to the lowercase param_type strings chartLayout.js / Card.js
// already filter by. Scoped only to that non-Navam family — Basic accounts
// never render Navam components, so Navam's vocabulary ("pulse", "hr",
// "rr") isn't part of this mapping.
const CHANNEL_TO_PARAM_TYPE = {
    FHR1: "fhr",
    FHR2: "fhr_two",
    TOCO: "uc",
    MHR: "mhr",
    SPO2: "spo2",
};

// BP/TEMP (and anything else not yet mapped) have no current UI field, but
// are still captured — lowercased, not dropped — so the data exists in
// Redux whenever UI support for them is added.
export function mapChannelToParamType(channelName) {
    return CHANNEL_TO_PARAM_TYPE[channelName] || channelName.toLowerCase();
}
